var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48 0 0 2.24 0 5C0 7.24 2.94 9.13 7 9.77V13L11 9L7 5V7.73C3.85 7.17 2 5.83 2 5C2 3.94 5.04 2 10 2C14.96 2 18 3.94 18 5C18 5.73 16.54 6.89 14 7.53V9.58C17.53 8.81 20 7.05 20 5C20 2.24 15.52 0 10 0V0Z",
    fill: "#44C032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurn);
export default __webpack_public_path__ + "static/media/turn.f1d16f4a5628be7c6c0e9cd6f0f88071.svg";
export { ForwardRef as ReactComponent };